import moment from 'moment';
import React from 'react';
import { InputNumber, DatePicker, Select, Row, Col, Form } from 'antd';
import CustomAvatar from './../components/customAvatar';
import { allLocations, allCurrencys } from './../utils/invoices';
import { formItemLayoutInvoice } from './../theme';
import { s3 } from './../utils';
const { Option } = Select;

function EditInvoiceForm({invoice, form, clients, contacts, candidates, users, submitting}) {
  const { getFieldDecorator } = form;

  const handleContact = (rule, value, callback) => {
    const { getFieldValue } = form;
    if (value && value === getFieldValue('contact')) {
      callback('Cannot be same to contact!');
    }
    callback();
  }

  return (
    <div>
    <Row>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="Client">
          {getFieldDecorator('client', {
            initialValue: invoice.client_docs.id,
            rules: [{ required: true, message: 'Please select client!' }],
          })(
            <Select
              disabled
              optionFilterProp={'label'}
              showSearch={true}
              placeholder="Select client"
              style={{ width: '100%' }}
            >
              {
                clients.map((i) => (
                  <Option label={i.name} key={i.id} value={i.id}>
                    <CustomAvatar
                      colourCode={i.name.charAt(0).toLowerCase()}
                      char={i.name.charAt(0).toUpperCase()}
                      charSize={11}
                      size={26}
                      src={i.avatar}
                    />
                    &nbsp;&nbsp;{i.name}
                  </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="Contact">
          {getFieldDecorator('contact', {
            initialValue: invoice.contact_docs.id,
            rules: [{ required: true, message: 'Please select contact!' }],
          })(
            <Select
              optionFilterProp={'label'}
              showSearch={true}
              placeholder="Select contact"
              style={{ width: '100%' }}
            >
              {
                contacts.map((i) => (
                  <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                    <CustomAvatar
                      colourCode={i.firstname.charAt(0).toLowerCase()}
                      char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                      charSize={11}
                      size={26}
                      src={i.avatar}
                    />
                    &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                  </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="CC with Contact">
          {getFieldDecorator('cc', {
            initialValue: invoice.cc,
          })(
            <Select
              mode="multiple"
              optionFilterProp={'label'}
              showSearch={true}
              placeholder="Select Contact CC"
              style={{ width: '100%' }}
            >
              {
                contacts.map((i) => (
                  <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                    <CustomAvatar
                      colourCode={i.firstname.charAt(0).toLowerCase()}
                      char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                      charSize={11}
                      size={26}
                      src={i.avatar}
                    />
                    &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                  </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
      </Col>
    </Row>

    <Row>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="Other Contact">
          {getFieldDecorator('additionalContact', {
            initialValue: invoice.additionalContact_docs ? invoice.additionalContact_docs.id : undefined,
            rules: [
              {
                validator: handleContact
              }
            ],
          })(
            <Select
              allowClear
              optionFilterProp={'label'}
              showSearch={true}
              placeholder="Select other contact"
              style={{ width: '100%' }}
            >
              {
                contacts.map((i) => (
                  <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                    <CustomAvatar
                      colourCode={i.firstname.charAt(0).toLowerCase()}
                      char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                      charSize={11}
                      size={26}
                      src={i.avatar}
                    />
                    &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                  </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="Candidate">
          {getFieldDecorator('candidate', {
            initialValue: invoice.candidate_docs.id,
            rules: [{ required: true, message: 'Please select candidate!' }],
          })(
            <Select
              disabled
              optionFilterProp={'label'}
              showSearch={true}
              placeholder="Select candidate"
              style={{ width: '100%' }}
            >
              {
                candidates.map((i) => (
                  <Option label={`${i.firstname} ${i.lastname}`} key={i.id} value={i.id}>
                    <CustomAvatar
                      colourCode={i.firstname.charAt(0).toLowerCase()}
                      char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                      charSize={11}
                      size={26}
                      src={i.avatar}
                    />
                    &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                  </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="Location">
          {getFieldDecorator('location', {
            initialValue: invoice.location,
            rules: [{ required: true, message: 'Please select location!' }],
          })(
            <Select
              disabled={submitting || moment() >= moment(invoice.onBoard)}
              showSearch={true}
              placeholder="Select location"
              style={{ width: '100%' }}
            >
              {
                allLocations.map((i) => (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
      </Col>
    </Row>

    <Row>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="On Board">
          {getFieldDecorator('onBoard', {
            initialValue: moment(invoice.onBoard),
            rules: [{ required: true, message: 'Please select on board local time!' }],
          })(
            <DatePicker 
              disabled={submitting || moment() >= moment(invoice.onBoard)}
              style={{ width: '100%' }}
              placeholder="Select on board local time" />
          )}
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="Fee">
          {getFieldDecorator('fee', {
            initialValue: invoice.fee,
            rules: [{ required: true, message: 'Please input fee!' }],
          })(
            <InputNumber 
              disabled={submitting}
              placeholder="Input fee"
              style={{ width: '100%' }}
              min={1} max={1000000} />
          )}
        </Form.Item>
      </Col>

      <Col span={8}>
        <Form.Item {...formItemLayoutInvoice} label="Currency">
          {getFieldDecorator('currency', {
            initialValue: invoice.currency,
            rules: [{ required: true, message: 'Please select currency!' }],
          })(
            <Select
              disabled={submitting}
              showSearch={true}
              placeholder="Select currency"
              style={{ width: '100%' }}
            >
              {
                allCurrencys.map((i) => (
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                ))
              }
            </Select>
          )}
        </Form.Item>
      </Col>
    </Row>

      <Row>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Rebate Term">
            {getFieldDecorator('rebateTerm', {
              initialValue: invoice.rebateTerm,
              rules: [{ required: true, message: 'Please input rebate term days!' }],
            })(
              <InputNumber 
                disabled
                style={{ width: '100%' }}
                min={0} max={365} />
            )}
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Payment Term">
            {getFieldDecorator('paymentTerm', {
              initialValue: invoice.paymentTerm,
              rules: [{ required: true, message: 'Please input payment term days!' }],
            })(
              <InputNumber 
                disabled
                style={{ width: '100%' }}
                min={1} max={365} />
            )}
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item {...formItemLayoutInvoice} label="Taken By">
            {getFieldDecorator('takenBy', {
              initialValue: invoice.takenBy,
              rules: [{ required: true, message: 'Please select recruiters!' }],
            })(
              <Select
                disabled={submitting}
                mode="multiple"
                optionFilterProp={'label'}
                showSearch={true}
                placeholder="Select recruiters"
                style={{ width: '100%' }}
              >
                {
                  users.map((i) => (
                    <Option label={`${i.firstname} ${i.lastname}`} key={i._id} value={i._id}>
                      <CustomAvatar
                        colourCode={i.firstname.charAt(0).toLowerCase()}
                        char={`${i.firstname.charAt(0).toUpperCase()}${i.lastname.charAt(0).toUpperCase()}`}
                        charSize={11}
                        size={26}
                        src={`${s3.baseURL}/${process.env.REACT_APP_S3_BUCKET}/avatar/user/${i.id}.jpeg`}
                      />
                      &nbsp;&nbsp;{`${i.firstname} ${i.lastname}`}
                    </Option>
                  ))
                }
              </Select>
            )}
          </Form.Item>
        </Col>
    </Row>
  </div>
  )
}

export default EditInvoiceForm;

